import { applyMiddleware, combineReducers, compose, createStore, StoreEnhancer } from 'redux';
import thunk from 'redux-thunk';

import { commutePopupReducer } from './commute_popup';
import { feedbackReducer } from './feedback';
import { filtersReducer } from './filters';
import { geoReducer } from './geo';
import { isFetchingReducer } from './is_fetching';
import { lastFiltersReducer } from './last_filters';
import { mobileReducer } from './mobile';
import { roadsReducer } from './roads';
import { savedFiltersReducer } from './saved_filters';
import { seoReducer } from './seo';
import { stationsReducer } from './stations';
import { userDataReducer } from './user';
import { villageListReducer } from './village_list';
import { IApplicationState, IReduxThunkContext, TReduxActions } from '../types/store';
import { DEFAULT_BLACK_FRIDAY_SETTINGS } from '../constants';

export function createReduxStore(
  context: IReduxThunkContext,
  preloadedState?: IApplicationState,
  debugEnabled?: boolean,
) {
  const reducer = combineReducers<IApplicationState>({
    commutePopup: commutePopupReducer,
    feedback: feedbackReducer,
    filters: filtersReducer,
    geo: geoReducer,
    isFetching: isFetchingReducer,
    lastFilters: lastFiltersReducer,
    mobile: mobileReducer,
    roads: roadsReducer,
    savedFilters: savedFiltersReducer,
    seo: seoReducer,
    stations: stationsReducer,
    userData: userDataReducer,
    villageList: villageListReducer,
    abGroup: (state = 0) => state,
    fatTooltipText: (state = '') => state,
    fatCardEnabled: (state = false) => state,
    abUseExperiments: (state = []) => state,
    blackFridaySettings: (state = DEFAULT_BLACK_FRIDAY_SETTINGS) => state,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  return createStore<IApplicationState, TReduxActions, IApplicationState, {}>(
    reducer,
    preloadedState as IApplicationState,
    composeEnhancers(applyMiddleware(thunk.withExtraArgument(context))) as unknown as StoreEnhancer<IApplicationState>,
  );
}
